import React, { Component } from "react";
import Slider from "react-slick";

const logos = [
  {
    url: "https://storage.googleapis.com/uapply/newcastle-university-logo.png",
    alt: "Newcastle University",
  },
  {
    url: "https://storage.googleapis.com/uapply/logo-cardiff.png",
    alt: "Cardiff University",
  },
  {
    url: "https://storage.googleapis.com/uapply/bangor_logo.webp",
    alt: "Bangor University",
  },
  {
    url: "https://storage.googleapis.com/uapply/university-of-greenwich-logo.png",
    alt: "University of Greenwich",
  },
  {
    url: "https://storage.googleapis.com/uapply/heriot-university.png",
    alt: "Heriot-Watt University",
  },
  {
    url: "https://storage.googleapis.com/uapply/university-of-reading-removebg-preview.png",
    alt: "University of Reading",
  },
  {
    url: "https://storage.googleapis.com/uapply/swansea-university.png",
    alt: "Swansea University",
  },
  {
    url: "https://storage.googleapis.com/uapply/queen-marry-university.png",
    alt: "Queen Mary University of London",
  },
  {
    url: "https://storage.googleapis.com/uapply/keele-university-removebg-preview.png",
    alt: "Keele University",
  },
  {
    url: "https://storage.googleapis.com/uapply/soas-university-of-london-logo.png",
    alt: "SOAS University of London",
  },
  {
    url: "https://storage.googleapis.com/uapply/Teesside-university.png",
    alt: "Teesside University",
  },
  {
    url: "https://storage.googleapis.com/uapply/northumbria_university_logo-removebg.png",
    alt: "Northumbria University",
  },
  {
    url: "https://storage.googleapis.com/uapply/university_of_strathclyde_logo-removebg-preview.png",
    alt: "University of Strathclyde",
  },
  {
    url: "https://storage.googleapis.com/uapply/university-of-bristol-logo-removebg.png",
    alt: "University of Bristol",
  },
  {
    url: "https://storage.googleapis.com/uapply/university-of-east-anglia-logo.png",
    alt: "University of East Anglia",
  },
  {
    url: "https://storage.googleapis.com/uapply/University-of-Essex-logo-removebg-preview.png",
    alt: "University of Essex",
  },
  {
    url: "https://storage.googleapis.com/uapply/University-of-Liverpool-Logo.png",
    alt: "University of Liverpool",
  },
  {
    url: "https://storage.googleapis.com/uapply/university-of-york-logo.png",
    alt: "University of York",
  },
  {
    url: "https://storage.googleapis.com/uapply/UoSheffield-Logo.png",
    alt: "University of Sheffield",
  },
  {
    url: "https://storage.googleapis.com/uapply/keele-university-removebg-preview.png",
    alt: "Keele University",
  },
];

export default class LogoSlider extends Component {
  render() {
    var settings = {
      dots: true,
      autoplay: true,
      speed: 4000,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      rows: 2,
      infinite: true,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false,
            rows: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            rows: 2,
            infinite: true,
          },
        },
      ],
    };

    return (
      <div className="logo-slider-container">
        <Slider className="logo-slick-slider" {...settings}>
          {logos.map((logo, index) => (
            <div key={index} className="logo-slider-img-con w-100">
              <div
                className="logo-image"
                style={{
                  backgroundImage: `url(${logo.url})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  height: "100px",
                  display: "block",
                  margin: "0 auto",
                }}
                aria-label={logo.alt}
                role="img"
                title={logo.alt}
              />
            </div>
          ))}
        </Slider>

        <style jsx>{`
          .logo-slider-container {
            width: 100%;
            padding: 20px 0;
            background: #f8f9fa;
          }

          .logo-slick-slider {
            margin: 0 auto;
            max-width: 1200px;
          }

          .logo-slider-img-con {
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .logo-image {
            transition: transform 0.3s ease;
            cursor: pointer;
          }

          .logo-image:hover {
            transform: scale(1.05);
          }

          /* Slick slider custom styles */
          .slick-prev:before,
          .slick-next:before {
            color: #007bff;
            font-size: 24px;
          }

          .slick-dots li button:before {
            font-size: 12px;
            color: #007bff;
          }

          .slick-dots li.slick-active button:before {
            color: #0056b3;
          }

          @media (max-width: 768px) {
            .logo-image {
              height: 80px;
            }

            .logo-slider-img-con {
              padding: 5px;
            }
          }
        `}</style>
      </div>
    );
  }
}
